import { createElement as $$createElement, setStyle as $$setStyle, setDataset as $$setDataset, setEvent as $$setEvent, delegateEvent as $$delegateEvent, setHTMLProp as $$setHTMLProp, setHTMLAttr as $$setHTMLAttr, setHTMLProps as $$setHTMLProps, setHTMLAttrs as $$setHTMLAttrs, createTextNode as $$createTextNode, updateText as $$updateText, insertNode as $$insertNode, ForNode as $$ForNode, CondNode as $$CondNode, ExpNode as $$ExpNode, EnvNode as $$EnvNode, TryNode as $$TryNode, SnippetNode as $$SnippetNode, PropView as $$PropView, render as $$render } from "@dlightjs/dlight";
import { View, type Pretty, type Typed, ContentProp, required, DLightViewProp } from "@dlightjs/dlight";
import { RouteEnv } from "./types";
import { Navigator } from "./Navigator";
import { getHashLocation, getHistoryLocation } from "./utils";
interface LinkProps {
  /**
   * @brief The content of the link
   */
  content?: ContentProp<string>;
  /**
   * @brief The path to navigate to
   */
  to: string;
  /**
   * @brief The mode of navigation, will retrieved from the navigator if not provided
   */
  mode?: "hash" | "history";
  /**
   * @brief The style of the a tag
   */
  style?: Record<string, string>;
  /**
   * @brief The class of the a tag
   */
  class?: string;
}
class Link extends View implements LinkProps {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }
  $p$content;
  _$contentKey = "content";
  content: LinkProps["content"] = required;
  $$content = 1;
  $p$to;
  to: LinkProps["to"] = required;
  $p$mode;
  mode: LinkProps["mode"] = "history";
  $$mode = 4;
  $s$mode = ["nav"];
  $p$style;
  style?: LinkProps["style"] = {};
  $$style = 8;
  $p$class;
  class?: LinkProps["class"] = "";
  $$class = 16;
  get children() {
    return this._$children;
  }
  $e$navigator;
  navigator: RouteEnv["navigator"] = required;
  $$navigator = 32;
  $s$navigator = ["nav"];
  nav;
  get $f$nav() {
    if (this._$cache("nav", [this.navigator, this.mode])) {
      return this.nav;
    }
    return this.navigator ?? new Navigator(this.mode);
  }
  handleClick(e: Event) {
    e.preventDefault();
    if (this.to.startsWith("http")) return window.open(this.to, "_blank");
    if (this.to.startsWith("?")) {
      // ---- return current path with query
      const currentPath = this.nav.mode === "history" ? getHistoryLocation() : getHashLocation();
      return this.nav.to(currentPath + this.to);
    }
    this.nav.to(this.to);
  }
  Body() {
    let $node0, $node1;
    this._$update = $changed => {
      if ($changed & 1) {
        $node1 && $node1.update(() => this.children ?? this.content, [this.content]);
      }
      if ($changed & 8) {
        $node0 && $$setStyle($node0, this.style);
      }
      if ($changed & 16) {
        $node0 && $$setHTMLProp($node0, "className", () => this.class, [this.class]);
      }
    };
    $node0 = $$createElement("a");
    $$setStyle($node0, this.style);
    $$setHTMLProp($node0, "className", () => this.class, [this.class]);
    $$delegateEvent($node0, "click", this.handleClick);
    $node1 = new $$ExpNode(this.children ?? this.content, [this.content]);
    $$insertNode($node0, $node1, 0);
    $node0._$nodes = [$node1];
    return [$node0];
  }
}
export default ((Link as Pretty) as Typed<LinkProps>);